// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__IVb6F","content":"LoadingAlert_content__2yaL0"};